import { createFileRoute } from '@tanstack/react-router';

import { requireAuth } from '@/app/lib/auth-guard';
import { PaymentHistoryPage } from '@/billing/pages/payment-history';

export const Route = createFileRoute('/billing/payments')({
  beforeLoad: async (ctx) => {
    await requireAuth(ctx);
  },
  component: PaymentsRoute,
  staticData: {
    headerSection: 'billing'
  }
});

function PaymentsRoute() {
  return <PaymentHistoryPage/>;
}
